/**
 * Tracking
 *
 * @selector [data-tracking]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';

const DEFAULT_TRACKING = {
    category: 'generic', // required
    action: 'body', // required
    label: undefined, // (optional, aber empfohlen)
    value: undefined, // (optional)
};

export default class Tracking extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;
        this.$el = $(element);
        this.data = this.$el.data('tracking');
        this.$document = $(document);

        const trackingData = this.el.dataset.tracking === '' ? {} : this.el.dataset.tracking;

        this.track = Object.assign({}, DEFAULT_TRACKING, JSON.parse(trackingData));

        window.dataLayer = window.dataLayer || [];

        this.bindListeners();

        return this;
    }

    bindListeners() {
        this.on('click', this.onAction);
    }

    onAction(e) {
        var eventType = e.type;

        this.trackAction(eventType);
    }

    trackAction(action) {
        this.track.action = action;

        if (typeof this.data === 'string') {
            this.data = this.data.split(',');

            this.track.category = this.data[0];
            this.track.action = this.data[1];
            this.track.label = this.data[2];
            this.track.value = this.data[3];
        } else {
            // object
            // this.track = $.extend({}, this.track, this.data);
            this.track.event = this.data.event;
            this.track.category = this.data.category || this.track.category;
            this.track.action = this.data.action || this.track.action;
            this.track.label = this.data.label || this.track.label;
            this.track.value = this.data.value || this.track.value;

            if (this.data.checkIfChecked) {
                this.track.label = this.$el.prop('checked') ? 'active' : 'inactive';
            }
        }

        this.sendEvent({ ...this.track });
    }

    sendEvent(data) {
        try {
            this.pushEvent(data);
        } catch (err) {
            console.log("Error tracking: ('send', 'event', " + JSON.stringify(data) + ')', err);
        }
    }

    pushEvent(event) {
        console.log('Push to dataLayer: ', event);
        window.dataLayer.push(event);
    }
}
